<template>
  <div class="result-page">
    <div class="stockli__form-intro bkgr-airborne">
      <div class="stockli__form-intro--text black-trans-bkgr">
        <div class="h4 white-text mb-0">You're Done!</div>
      </div>
    </div>
    <div class="stockli__form-container">
      <div class="h1">Thank you.</div>

      <p>Your indicator setting: {{ savedIndicator }}</p>
      <p></p>
      <p class="mb-4">For your convenience, we will also send you a text message with your results in a few seconds.</p>
      <p>
        When you are ready to demo skis at today's event,
        <span class="highlight">please share your indicator setting with your Stockli sales representative, and let them know that you have submitted this release form.</span>
        We will also send you an email later today with details about the skis you tested and other details.
      </p>
      <div class="pt-12 pb-12">
        <a class="btn" href="https://www.stoeckli.ch/usen/ski/ski-finder" target="_blank" rel="noopener">Try the Stockli Ski Finder</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReleaseComplete",
  components: {
  },
  data: () => ({
  }),
  computed: {
    savedIndicator() {
      return this.$store.state.savedIndicator;
    },
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style scoped lang="scss">
</style>
